
//npm install -g firebase-tools
//npm i firebase

import firebase from 'firebase/app'

import 'firebase/auth'


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBGNteQUWqgr9dViF87OkZTd-A8dQL0ouM",
  authDomain: "ecomm-16453.firebaseapp.com",
  databaseURL: "https://ecomm-16453.firebaseio.com",
  projectId: "ecomm-16453",
  storageBucket: "ecomm-16453.appspot.com",
  messagingSenderId: "287239354599",
  appId: "1:287239354599:web:d240a2078caf30db5d8a42",
  measurementId: "G-V673VS4G5V"
};




// const app = firebase.initializeApp({
//   apiKey: "AIzaSyBGNteQUWqgr9dViF87OkZTd-A8dQL0ouM",
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID,
//   measurementId: process.env.REACT_APP_FIREBASE_MEASURMENT_ID
// })

const firebaseApp = firebase.initializeApp(firebaseConfig)

const db = firebaseApp.firestore;

const auth = firebase.auth() //auth instance to used everywhere 

export { db, auth };